import React from 'react';
import Box from 'core/ui/Box';
import FiltersTypesMembers from './Members/FiltersTypesMembers';

const FiltersMembershipCancelRequest = ({
  index,
  channelId,
  values,
  onChangeFiltersValues,
  excludeTypes,
}) => (
  <Box className="gap-10" display="flex" flexDirection="column">
    <FiltersTypesMembers
      index={index}
      channelId={channelId}
      values={values}
      onChangeFiltersValues={onChangeFiltersValues}
      excludeTypes={excludeTypes}
    />
  </Box>
);

export default FiltersMembershipCancelRequest;
